import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import Layout from '../../../layout';
import CardQuestion from './components/cardQuestion'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin:'50px auto',
        [theme.breakpoints.up('md')]: {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    title:{
        marginBottom:15,
    }
}))


export default function Index() {

    const classes = useStyles()



    return (
        <Layout>
            <div className={classes['root']}>
                {/* <h3 className={classes['title']}>سوالات متداول</h3> */}
                <CardQuestion />
            </div>
        </Layout>
    )
}


let data = [
    {
        title: 'نحوه‌ی استفاده از سامانه معاملات بر خط چگونه است؟',
        list: [
            "در نخستين‌گام براي دسترسي به سامانه معاملات برخط سهام، متقاضي بايد به يکي از شرکت‌هاي کارگزاري بورس در سراسر کشور مراجعه و درخواست خود براي دسترسي به سامانه معاملات برخط را به شرکت مذکور کنـد. يکي از پيش‌شرط‌هاي اساسي که سازمان بورس براي استفاده سرمايه‌گذار از سامانه معاملات برخط (آنلاين) تعيين کرده است، آشنايي کافي سرمايه‌گذار با اصول خريد و فروش اوراق بهادار در بورس، قوانين و مقررات اساسي مرتبط با سرمايه‌گذاري در بورس و نحوه استفاده از سامانه معاملـه برخط است؛ زيرا همان طور که گفته شد، در سامانه معاملات برخط، سرمايه‌گذار خود مستقيماً و بدون واسطه کارگزار، نسبت به خريد و فروش اوراق بهادار در بورس اقدام مي‌کند. بنابراين، لازم است آشنايي کافي با اصول و مقررات مرتبط با سرمايه‌گذاري در بورس را داشتـه باشد. و از دیگر مزایای این سامانه می توان به سرعت عمل در تصميم‌گيري، عدم محدوديت زماني و مکاني براي سرمايه‌گذاري، نقل و انتقال الکترونيک وجوه، کاهش اختلافات بين سرمايه‌گذار و کارگزار و امنيت بالاي سامانه معاملات برخط، اين سامانه با استقبال بسيار زياد سرمايه‌گذاران مواجه شده است.",
        ]
    },
    {
        title: 'چه زمانی نیاز به ثبت درخواست تغییر کارگزار ناظر است؟ ',
        list: [
            "فرض کنید دو ماه قبل برای اولین بار نماد فولاد را در یک کارگزاری خریداری کرده‌اید (و حتی بلافاصله فروخته‌اید). در حال حاضر کارگزار ناظر شما آن کارگزاری است. در صورتی که امروز هم نماد فولاد را در کارگزاری پویان  خریداری نمایید، در انتهای روز در پرتفوی یا سبدبان شما در کارگزاری قبلی قرار خواهد گرفت. جهت مشاهده دارایی خود در کارگزاری پویان  می‌بایست اقدام به تغییر کارگزار ناظر نمایید."
        ]
    },
    {
        title: 'پذیره نویسی چیست؟ ',
        list: [
            `
پذیره‌نویسی در لغت به معنای "نوشتن و امضاکردن در سند و نوشته" می‌باشد و در واقع به تعهد انجام کار یا تعهد امری که در سند به آن ذکر شده است، اشاره دارد. احتمالاً در بازار بورس نیز اصطلاح پذیره‌نویسی را شنیده‌اید؛ پذیره‌نویسی در بازارهای مالی به معنی فرایند خرید اوراق بهادار از ناشر و یا نماینده قانونی و پرداخت تعهد وجه کامل، طبق قرارداد است. یکی از موارد مهم در این اصطلاح، تعهد و تسهیل تأمین مالی می‌باشد؛ بهتر است بدانیم که فرایند پذیره‌نویسی، تأمین مالی را در شرکت‌ها بهتر و آسان‌تر کرده است   .`
        ]
    },
    {
        title: 'کارگزار ناظر چیست؟',
        list: [
            "پس از خریداری سهم، اطلاعات سهام خریداری‌شده باید در اختیار یک کارگزار قرار گیرد. این کارگزار به‌اصطلاح «کارگزار ناظر» نامیده می‌شود."
        ]
    },
    {
        title: 'شرایط دریافت اعتبار چیست؟ ',
        list: [
            "دریافت اعتبار از هر کارگزاری با توجه به شرایط تعیین شده توسط همان کارگزاری و طبق روال مشخص شده برای آن، امکان‌پذیر است. اما در حالت کلی، کارگزاران به مشتریان فعال‌تر خود اعتبار پرداخت می‌کنند. علاوه بر این، پرتفوی شخص متقاضی دریافت اعتبار نیز از نظر ارزش دارایی و تنوع، باید شرایط به‌خصوصی داشته باشد. "
        ]
    },
    {
        title: 'اعتبار چیست؟',
        list: [
            "اعتبار معاملاتی در بازار سرمایه در واقع وامی است که از طرف کارگزاران در اختیار معامله‌گران و سرمایه‌گذاران قرار می‌گیرد. ضوابط و دستورالعمل‌های مربوط به اعتبار معاملاتی توسط سازمان بورس و اوراق بهادار تهران تعیین می‌شود. علاوه بر آن، هر یک از کارگزاران فعال در بازار سرمایه نیز تحت شرایط خاصی به کاربران خود اعتبار پرداخت می‌کنند."
        ]
    },
    {
        title: 'به چه دلایلی ممکن است درخواست تغییر کارگزار ناظر با خطا مواجه شود؟ ',
        list: [
            "عدم دارایی در نماد مورد نظر، فریز بودن سهم، بدهکاری"
        ]
    },
    {
        title: 'قیمت روز یا قیمت بازاری سهام یعنی چه؟ ',
        list: [
            "قیمت روز یا قیمت بازاری به قیمت خرید و فروش یک سهم در بازار اشاره دارد. یعنی همان رقمی که امروز برای خرید یک سهم خاص باید بپردازید. این رقم لزوما با ارزش ذاتی سهام برابر نیست و ممکن است بیشتر یا کمتر از آن باشد. میزان عرضه و تقاضا، اوضاع سیاسی و اقتصادی کشور و جهان، هیجانات سرمایه‌گذاران و … روی قیمت روز سهام تاثیر می‌گذارند."
        ]
    },
    {
        title: 'عرضه اولیه چیست؟ ',
        list: [
            "زمانی که یک شرکت برای اولین بار سهام خود را در بازار ارائه می‌کند، عرضه اولیه صورت گرفته است. پس از تعیین قیمت، سهام به میزان مشخصی وارد بازار می‌شود و طبق تجربه قیمت آن تا چندین درصد افزایش پیدا خواهد کرد. به دلیل احتمال کسب سود بالا، مردم تمایل زیادی نسبت به خرید عرضه اولیه دارند و جو خوش‌بینانه‌ای در این زمینه حاکم است."
        ]
    },
]